import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Close from 'react-icons/lib/md/close';
import ChevronLeft from 'react-icons/lib/md/chevron-left';
import {FormattedMessage} from 'react-intl';
import Slide from '@material-ui/core/Slide';
import SvgIconButton from '../../../components/SvgIconButton';
import {isMobile} from '../../../utils/screenUtility';
import LessonPreviewContent from './LessonPreviewContent';
import DialogWrapper from '../../../components/dialog/Dialog';
import './lessonInfo.scss';
import NotationViewerContainer from "../../create/drawer/NotationViewerContainer";

class LessonFilePreviewDialog extends Component {
    render() {
        const {open, file, video, onClose, withHeader=true} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'left'},
            classes: {root: 'dialog-window', paper: 'paper'},
            open,
            onClose
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="file-preview">
                    <SvgIconButton containerClass="file-preview-close" disableRipple={true} onClick={onClose}>
                        {isMobile() ? <ChevronLeft /> : <Close />}
                    </SvgIconButton>
                    {withHeader && <h2 className="file-preview-heading">{file.name || <FormattedMessage id={`createLesson.${video ? 'videoPreview' : 'filePreview'}`}/>}</h2>}
                    <div className="file-preview-body">
                        {file.type ? <LessonPreviewContent video={video} file={file} onClose={onClose}/> :
                            <NotationViewerContainer size={"100%"} onClose={onClose} withControls={true}/>}

                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

LessonFilePreviewDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    file: PropTypes.object,
    video: PropTypes.string
};

export default LessonFilePreviewDialog;
